<template>
  <div class='core'>
    <div class='layui-layer-title' style='cursor: move;'>{{ title }}</div>
    <div class='layui-layer-content'>
      <div class='layui-layer-wrap'>
        <div class='form-collapse'>
          <div class='info'>
            <layui-form ref='wxPersonManagerMainViewRef' :show-form='true' :after-save='handleAfterSave' :rule='robotManageFormRule' :requestUniqueId='requestId'>
              <template slot-scope='{scope}'>
                <div class='layui-form'>
                  <template>
                    <layui-collapse>
                      <div class='layui-colla-item'>
                        <h2 class='layui-colla-title'>人员基本信息</h2>
                        <div class='layui-colla-content layui-show'>
                          <div class='layui-form-item-two'>
                            <div class='layui-form-item-left'>
                              <div class='pub-form'>
                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>姓名：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.PSN_NAME' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='PSN_NAME' placeholder='请输入姓名'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>公司名称：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.COMPANY_NAME' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='COMPANY_NAME' placeholder='请输入公司名称'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class="layui-form-label">品牌名称： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <layui-multiselect
                                      :single="true"
                                      ref="brandSelect"
                                      :enabled="!isBrowserStatus"
                                      name="BRAND_ID"
                                      @selectChange="brandChange($event)"
                                      table-name="YW_BRAND_DETAIL_V"
                                      text-field="BRAND_NAME"
                                      value-field="BRAND_ID"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.BRAND_ID"
                                    ></layui-multiselect>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>手机号：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.PSN_PHONE' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='PSN_PHONE' placeholder='请输入手机号'/>
                                  </div>
                                </div>


                                <div class='layui-form-item'>
                                  <label class='layui-form-label'><span class="x-red">*</span>企业成员帐号：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.USER_ID' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='USER_ID' placeholder='请输入企业成员帐号'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'></label>
                                  <div class='layui-input-inline' style='width: 60%; color: #959595'>
                                    提示：管理员可在管理后台【通讯录->成员信息】查看成员帐号或在【手机端->通讯录->右上角编辑->选择成员->编辑成员】可查看成员帐号
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>职务：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <input type='text' :disabled="isBrowserStatus" v-model='config.form.POST_NAME' autocomplete='off'
                                           :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'" name='POST_NAME' placeholder='请输入职务名称'/>
                                  </div>
                                </div>

                                <div class='layui-form-item'>
                                  <label class='layui-form-label'>备注：</label>
                                  <div class='layui-input-inline' style='width: 60%;'>
                                    <textarea  :disabled="isBrowserStatus" v-model='config.form.MEMO' autocomplete='off' :class="isBrowserStatus ? 'layui-textarea layui-disabled' : 'layui-textarea'" name='MEMO' placeholder='请输入备注'/>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>

                <div class='layui-form-btn'>
                  <div class='layui-footer'>
                    <button class='layui-btn refresh' title='关闭' @click='onCancelBtn()'>关 闭</button>
                    <button class='layui-btn' v-if="!isBrowserStatus" title='保存' @click='onSaveBtn()'>保 存</button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestId: 'wxPersonManageFormRequest',
      robotManageFormRule: {
        PSN_NAME: {required: {message: '姓名不能为空'}},
        PSN_PHONE: {required: {message: '手机号不能为空'}},
        USER_ID: {required: {message: '企业成员帐号不能为空'}},
      },
      config: {form: {}},
      formData: {},
      title: '',
      storeList: [],
      removeType: '',
      tipAlert: "请选择客户",
      isBrowserStatus: false,
      customerStoreExtNames: ''
    }
  },

  mounted() {
    if (this.tabParam) {
      this.formData = this.tabParam.editRow
      this.tableObj = this.tabParam.tableObj
      this.formType = this.tabParam.formType
      this.title = this.tabParam.title

      if (this.formType === 'browser') {
        this.config.form = this.formData
        this.removeType = 'multi-remove'
        this.tipAlert = ""
        this.isBrowserStatus = true
        this.customerStoreExtNames = this.formData.CUSTOMER_STORE_EXT_NAMES
      }

      if (this.formType === 'edit') {
        this.config.form = this.formData
        this.removeType = 'multi-remove'
        this.tipAlert = ""
      }
    }
  },

  methods: {
    handleAfterSave() {
      this.baseComponent.loadComponentByName('wxPersonManage')

      if (this.tableObj) {
        this.tableObj.pageInfo.pageIndex = 1
        this.tableObj.load()
      }
    },

    //品牌变化
    brandChange(data) {
      if (data.length > 0) {
        this.config.form['BRAND_ID'] = data[0]._row.BRAND_ID
        this.config.form['BRAND_NAME'] = data[0]._row.BRAND_NAME
      } else {
        this.config.form.BRAND_ID = ''
        this.config.form.BRAND_NAME = ''
        this.$refs.brandSelect.queryCondition.BRAND_NAME = ''
        this.$refs.brandSelect.refreshAsyncData()
      }
    },

    onCancelBtn() {
      // this.baseComponent.loadComponentByName('qrCodeManage')
      this.baseComponent.closeComponent(this.tabParam.cloneMenu);
    },

    renderClientText(row) {
      if (row) {
        if (!row.STORE_ID) {
          return '--请选择--'
        } else {
          var arr = [];
          arr.push('门店【 ' + row['STORE_NAME'] + ' 】');
          this.storeName = arr.join(" ")
          return arr.join(" ");
        }
      }
    },
    storeManagerOnChange(selectData) {
      if (selectData != null && selectData.length > 0) {
        this.config.form['STORE_MANAGER_ID'] = selectData[0].value
        this.config.form['STORE_MANAGER'] = selectData[0].name
      } else {
        this.config.form['STORE_MANAGER_ID'] = ''
        this.config.form['STORE_MANAGER'] = ''
      }
    },
    onSaveBtn() {
      this.$refs.wxPersonManagerMainViewRef.editRow = this.config.form

      this.$refs.wxPersonManagerMainViewRef.callableSave('YW_ROBOT_WX_PSN')
    },

    storeOnChange(selectData) {
      if (this.formType === 'edit') {
        // 修改状态，如果已经存在，则在此基础上删除  此时selectData为对象
        let customer_store_ids = this.config.form['CUSTOMER_STORE_IDS'];
        let customer_store_ext_names = this.config.form['CUSTOMER_STORE_EXT_NAMES'];

        if (selectData && selectData.hasOwnProperty("STORE_ID")) {
          let customer_store_id_array = [];
          let customer_store_ext_name_array = [];

          if (customer_store_ids && customer_store_ids.length > 0) {
            customer_store_id_array = customer_store_ids.split(',')
            customer_store_ext_name_array = customer_store_ext_names.split(',')
          }

          customer_store_id_array.remove((selectData.STORE_ID).toString())
          customer_store_ext_name_array.remove(selectData.STORE_NAME)

          // this.storeList = selectData;
          this.tipAlert = ""
          this.config.form['CUSTOMER_STORE_IDS'] = customer_store_id_array.join(",");
          this.config.form['CUSTOMER_STORE_EXT_NAMES'] = customer_store_ext_name_array.join(",");
        } else {
          // 修改状态，如果已经存在，则在此基础上添加  此时selectData 为数组
          if (customer_store_ids) {
            let customer_store_id_arr = []
            customer_store_id_arr  = customer_store_ids.split(',')
            let customer_store_ext_name_arr = []
            customer_store_ext_name_arr = customer_store_ext_names.split(',')

            customer_store_id_arr.push(selectData[0]['STORE_ID'].toString());
            let new_customer_store_ext_ids =customer_store_id_arr;
            customer_store_ext_name_arr.push(selectData[0]['STORE_NAME']);
            let new_customer_store_ext_names = customer_store_ext_name_arr

            this.tipAlert = ""
            this.config.form['CUSTOMER_STORE_IDS'] = new_customer_store_ext_ids.join(",");
            this.config.form['CUSTOMER_STORE_EXT_NAMES'] = new_customer_store_ext_names.join(",");
          } else {
            let customer_store_id_arr = []
            let customer_store_ext_name_arr = []

            customer_store_id_arr.push(selectData[0]['STORE_ID'].toString());
            let new_customer_store_ext_ids =customer_store_id_arr;
            customer_store_ext_name_arr.push(selectData[0]['STORE_NAME']);
            let new_customer_store_ext_names = customer_store_ext_name_arr

            this.tipAlert = ""
            this.config.form['CUSTOMER_STORE_IDS'] = new_customer_store_ext_ids.join(",");
            this.config.form['CUSTOMER_STORE_EXT_NAMES'] = new_customer_store_ext_names.join(",");
          }
        }
      } else {
        if (selectData != null && selectData.length > 0) {
          let customer_store_id_array = [];
          let customer_store_ext_name_array = [];

          for (let item of selectData) {
            customer_store_id_array.push(item.STORE_ID)
            customer_store_ext_name_array.push(item.STORE_NAME)
          }

          this.storeList = selectData;
          this.tipAlert = ""
          this.config.form['CUSTOMER_STORE_IDS'] = customer_store_id_array.join(",");
          this.config.form['CUSTOMER_STORE_EXT_NAMES'] = customer_store_ext_name_array.join(",");
        } else {
          this.tipAlert = "请选择客户"
          this.config.form['CUSTOMER_STORE_EXT_IDS'] = "";
          this.config.form['CUSTOMER_STORE_EXT_NAMES'] = "";
        }
      }


    }


  }
}
</script>




// WEBPACK FOOTER //
// src/components/repairs/wxPersonManage/wxPersonManageForm.vue